import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { CustomFile } from '../../../../../../../models/interfaces/custom_file.interface';
import { AlertService } from '../../../../../../../core/services/alert/alert.service';
import { UtilsService } from '../../../../../../../shared/utils/utils.service';
import { ToastService } from '../../../../../../../core/services/toast/toast.service';
import { ApiService } from '../../../../../../../core/services/api/api.service';
import { cloneDeep } from 'lodash-es';
import { firstValueFrom } from 'rxjs';
import { EnfafInputFileDraggerLightComponent } from '../../../../../../../components/enfaf-input-file-dragger-light/enfaf-input-file-dragger-light.component';
import { EnfafModalComponent } from '../../../../../../../components/enfaf-modal/enfaf-modal.component';

@Component({
  selector: 'app-modal-student-course-assignment',
  imports: [MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatButtonModule, EnfafInputFileDraggerLightComponent, EnfafModalComponent],
  templateUrl: './modal-student-course-assignment.component.html',
  styleUrl: './modal-student-course-assignment.component.scss'
})
export class ModalStudentCourseAssignmentComponent implements OnInit {
  courseId!: string;
  courseName!: string;
  showCloseAlert = false;
  csvToUpload: CustomFile | null = null;
  isAssigning = false;
  title = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalStudentCourseAssignmentComponent>,
    private alert: AlertService,
    private utils: UtilsService,
    private toast: ToastService,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    const receivedData = this.data ? cloneDeep(this.data) : null;
    this.courseId = receivedData?.courseId;
    this.courseName = receivedData?.courseName;
    if (!this.courseId || !this.courseName) {
      this.closeModal();
      return;
    }
    this.title = `Asignación del curso "${this.courseName}" mediante CSV`;
  }

  async confirmCloseModal(): Promise<any> {
    if (this.showCloseAlert) {
      const closeModal = await this.alert.presentCloseWindowAlert();
      return closeModal ? this.closeModal() : null;
    }

    this.closeModal();
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  onDroppedFiles(files: Array<CustomFile>): void {
    if (!files?.length) return;

    for (const file of files) {
      file.name = this.utils.generateFileName(file.name);
    }

    this.csvToUpload = files[0];
  }

  onLocalFileDeleted(): void {
    this.csvToUpload = null;
  }

  async assignMassiveCourse(): Promise<void> {
    try {
      if (!this.csvToUpload) return;

      this.isAssigning = true;
      const formData = new FormData();
      const body = { courseId: this.courseId };
      formData.append('form', JSON.stringify(body));
      formData.append('csv', this.csvToUpload.file, this.csvToUpload.name);
      const response = await firstValueFrom(this.api.assignMassiveCourseCsv(formData));
      this.isAssigning = false;
      this.toast.presentSuccessToast(response.message, 5000);
      this.closeModal();
    } catch (errorResponse: any) {
      this.isAssigning = false;
      const errorMessage = errorResponse?.error?.message;
      this.toast.presentErrorToast(errorMessage || 'Hubo un error asignando curso');
    }
  }
}
